import React, { useCallback, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import GridItem from "../../../components/Grid/GridItem.js";
import GridContainer from "../../../components/Grid/GridContainer.js";
import Button from "../../../components/CustomButtons/Button.js";
import { useHistory, useLocation } from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import { controlLabelColor, primaryColor } from "../../../style.scss";
import Danger from "../../../components/Typography/Danger";
import { loginToApp, logoutFromApp } from "../../../redux-services/actions/actions";
import { connect } from "react-redux";
import { DCustomerManagementApi } from "eclipse-react-sdk/services/apis/dcustomer-management-api";
import { SpinnerComponent } from 'react-element-spinner';
import formStyle from "../../../assets/jss/eclipse/components/formStyle.js";
import themeStyle from "../../../assets/jss/eclipse/components/themeStyle.js";
import AlertNotification from "../../../components/Snackbar/AlertNotification.js";
import { EclipseTitle, RatifyType } from "eclipse-react-sdk/services/models";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { MenuItem } from "@material-ui/core";
import HttpRequestConfiguration from "../../../http-request-configuration.js";
import moment from "moment";

const useStyles = makeStyles(themeStyle);
const ValidationTextField = withStyles(formStyle)(TextField);

export function PersonalInformation(props) {
  const appData = props?.appData;
  const tenantId = appData?.auth?.tenantId;
  const customer = appData?.customer;
  const assistedCustomer = { ...appData?.assistedCustomer };
  const ratifyRules = appData?.template?.ratifyRules;
  const addressOnRegister = appData?.template?.pwaAppOptions?.addressOnRegister;
  const pageState = useLocation().state;
  const selectedDocument = pageState?.selectedDoc;
  const document = pageState?.document;
  const idDocument = pageState?.idDocument;
  const idDocumentBack = pageState?.idDocumentBack || null;
  const idDocumentImageData = pageState?.idDocumentImageData || null;
  const idDocumentBackImageData = pageState?.idDocumentBackImageData;
  const selfieDocumentImageData = pageState?.selfieDocumentImageData;
  const fromScreen = pageState?.fromScreen;
  const isAssistedSigUp = fromScreen === 'ASSISTED_SIGNUP';
  const isAddressAdded = pageState?.isAddressAdded;
  let ratifyKeys = ratifyRules[document?.type];
  const isExpiryDateEnable = selectedDocument === '1';
  const classes = useStyles();
  const history = useHistory();
  const currentDate = new Date().toISOString().split('T')[0];
  const [inputs, setInputs] = useState({
    title: '',
    firstName: '',
    surname: '',
    identityNumber: '',
    expiryDate: new Date().toISOString().split('T')[0]
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [alertData, setAlert] = useState(null);
  const showAlert = (alertDisplay, alertType, message) => {
    setAlert({ isAlertDisplay: alertDisplay, alertType: alertType, alertMessage: message })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }

  const redirectToErrorScreen = (fromScreen, toScreen) => {
    history.push({
      pathname: toScreen,
      state: { fromScreen }
    });
  }

  const backToHome = useCallback(() => {
    history.push({
      pathname: `/pages/selfie-initial`,
      state: {
        isAddressAdded,
        fromScreen,
        selectedDocument,
        selectedDoc: selectedDocument,
        document,
        idDocument,
        idDocumentBack,
        idDocumentImageData,
        idDocumentBackImageData,
        selfieDocumentImageData
      },
    });
  }, [history, isAddressAdded, fromScreen, selectedDocument, document, idDocument, idDocumentBack, idDocumentImageData, idDocumentBackImageData, selfieDocumentImageData]);

  React.useEffect(() => {
    return () => {
      window.onpopstate = () => {
        backToHome();
      }
    };
  }, [backToHome])
  
  React.useEffect(() => {
      if (document?.type && document.type === "PASSPORT") {
          if (idDocument?.extraInfo) {
              const extraInfo = JSON.parse(idDocument.extraInfo);
              if (extraInfo?.extractedDataResult) {
                  const extractedDataResult = JSON.parse(extraInfo.extractedDataResult);
                  setInputs({
                      title: "",
                      firstName: extractedDataResult.firstName,
                      surname: extractedDataResult.lastName,
                      identityNumber: extractedDataResult.passportNumber,
                      expiryDate: moment(extractedDataResult.expiryDate).format("YYYY-MM-DD"),
                  });
              }
          }
      }
  }, [idDocument, document.type]);

  const goToAddAddress = () => {
    history.push({
      pathname: `/pages/permanent-address`,
      state: { fromScreen }
    });
  }
  const goToSuccessRatifyKYC = () => {
    history.push({
      pathname: (isAssistedSigUp ? `/pages/assisted-signup-account-ready` : `/pages/ratify-kyc-success`),
    });
  }

  const goToFailedRatifyKYC = (ratifyProcessData) => {
    history.push({
      pathname: `/pages/ratify-kyc-error`,
      state: { selectedDoc: selectedDocument, ratifyProcessData, fromScreen }
    });
  }

  const doRatifyProcess = () => {
    const httpRequestConfiguration = HttpRequestConfiguration((isAssistedSigUp ? assistedCustomer?.assistedUserToken : null));
    const doRatifyProcessAPI = new DCustomerManagementApi(httpRequestConfiguration);
    const requestBody = {
      type: RatifyType.NORMAL
    }
    doRatifyProcessAPI.tenantsTenantIdCustomersCustomerIdRatifyPost(tenantId, (isAssistedSigUp ? assistedCustomer?.customerId : customer?.customerId), requestBody).then((doRatifyProcessAPIResponse) => {
      let isRatifyFailed = 0;
      let ratifiedFailedResponse = {};
      ratifyKeys.forEach(ratifyKey => {
        ratifiedFailedResponse[ratifyKey] = doRatifyProcessAPIResponse.data[ratifyKey]['passed'];
        if (!doRatifyProcessAPIResponse.data[ratifyKey]['passed']) {
          isRatifyFailed = isRatifyFailed + 1;
        }
      });
      appData.template.ratifyTrialCount = (isAssistedSigUp ? 0 : appData?.template?.ratifyTrialCount + 1);
      props.personalInformationHandler({ ...appData });
      setLoading(false);
      if (isRatifyFailed > 0) {
        goToFailedRatifyKYC(ratifiedFailedResponse)
      } else {
        if (addressOnRegister && !isAddressAdded) {
          goToAddAddress();
        } else {
          goToSuccessRatifyKYC();
        }
      }
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        if (isAssistedSigUp) {
          redirectToErrorScreen('/pages/assisted-signup', '/pages/error');
        } else {
          redirectToErrorScreen('/pages/identity-document', '/pages/error');
        }
      }
    });
  }

  const handlePersonalInformationFormSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validatePersonalInformationForm(inputs);
    const noErrors = Object.keys(validationErrors).length === 0;
    setErrors(validationErrors);
    if (noErrors) {
      setLoading(true);
      const customerExistingData = isAssistedSigUp ? assistedCustomer : customer;
      const httpRequestConfiguration = HttpRequestConfiguration((isAssistedSigUp ? assistedCustomer?.assistedUserToken : null));
      const updateCustomerDetailAPI = new DCustomerManagementApi(httpRequestConfiguration);
      updateCustomerDetailAPI.tenantsTenantIdCustomersCustomerIdGet(tenantId, customerExistingData?.customerId).then((updateCustomerDetailAPIResponse) => {
        const customerData = updateCustomerDetailAPIResponse?.data;
        const requestBody = {
          ...customerData,
          title: inputs?.title,
          firstName: inputs?.firstName,
          lastName: inputs?.surname,
          nationalIdentityNumber: isExpiryDateEnable ? null : inputs?.identityNumber,
          passportExpiry: isExpiryDateEnable ? inputs?.expiryDate.replace(/-/g, '') : customerData?.passportExpiry,
          passportNumber: isExpiryDateEnable ? inputs?.identityNumber : null
        }

        updateCustomerDetailAPI.tenantsTenantIdCustomersCustomerIdPut(tenantId, customerExistingData?.customerId, requestBody).then((updateCustomerDetailAPIResponse) => {
          if (isAssistedSigUp) {
            appData.assistedCustomer = { ...assistedCustomer, ...updateCustomerDetailAPIResponse.data };
          } else {
            appData.customer = { ...updateCustomerDetailAPIResponse.data };
          }
          props.personalInformationHandler({ ...appData });
          doRatifyProcess();
        }).catch((error) => {
          setLoading(false);
          if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
            showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
          } else {
            if (isAssistedSigUp) {
              redirectToErrorScreen('/pages/assisted-signup', '/pages/error');
            } else {
              redirectToErrorScreen('/pages/identity-document', '/pages/error');
            }
          }
        });
      }).catch((error) => {
        setLoading(false);
        if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
          showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
        } else {
          if (isAssistedSigUp) {
            redirectToErrorScreen('/pages/assisted-signup', '/pages/error');
          } else {
            redirectToErrorScreen('/pages/identity-document', '/pages/error');
          }
        }
      });
    }
  }

  const handleInputChange = (event) => {
    event.persist();
    inputs[event.target.name] = event.target.value;
    setInputs(inputs);
    const validationErrors = validatePersonalInformationForm(inputs);
    setErrors(validationErrors);
  }


  const handleInputKeyUp = (event) => {
    event.persist();
    const validationErrors = validatePersonalInformationForm(inputs);
    setErrors(validationErrors);
  }

  const validatePersonalInformationForm = (inputs) => {
    const errors = {}

    if (!inputs.title) {
      errors.title = 'Title is required!'
    }

    if (!inputs.firstName) {
      errors.firstName = 'First name required!'
    } else if (!/^[A-Za-z0-9]+[ a-zA-Z0-9-]{1,}$/i.test(inputs.firstName)) {
      errors.firstName = 'First name is invalid!'
    }

    if (!inputs.surname) {
      errors.surname = 'Surname required!'
    } else if (!/^[a-zA-Z0-9][ a-zA-Z0-9-]{2,}$/i.test(inputs.surname)) {
      errors.surname = 'Surname is invalid!'
    }

    if (!inputs.identityNumber) {
      errors.identityNumber = 'Identity number required!'
    } else if (!/^[a-zA-Z0-9]{3,}$/i.test(inputs.identityNumber)) {
      errors.identityNumber = 'Identity number is invalid!'
    }

    if (!inputs.expiryDate) {
      errors.expiryDate = 'Expiry date required!'
    }
    return errors
  }

  return (
    <div>
      <SpinnerComponent loading={isLoading} position="global" color={primaryColor} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div className={'progress-bar'}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <p onClick={() => {
                backToHome()
              }} style={{ display: 'flex', alignItems: 'center', fontSize: 18 }}>
                <ArrowBackIosIcon />
                <span>{"Back"}</span>
              </p>
              <small style={{
                color: controlLabelColor,
                marginLeft: "auto"
              }}>Step {isAssistedSigUp ? 5 : 4} of 5</small>
            </div>
            <strong><small
              style={isAssistedSigUp ? { width: '100%' } : { width: '80%' }}>&nbsp;</small></strong>
          </div>
          <form onSubmit={handlePersonalInformationFormSubmit}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <h1 className='auth-title'
                  dangerouslySetInnerHTML={{ __html: isAssistedSigUp ? 'Almost done with <br />verification!' : 'Almost done with <br />your verification!' }} />
                <p className={classes.regularFontSize}>
                  <strong>{isAssistedSigUp ? "Please complete the customer's personal information." : "Please complete the following personal information."}</strong>
                </p>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <ValidationTextField
                  fullWidth
                  label={isAssistedSigUp ? "Title" : "Your title"}
                  select
                  variant="filled"
                  id="title"
                  type="number"
                  error={!!(errors.title)}
                  name="title"
                  value={inputs.title}
                  onChange={handleInputChange}
                  onKeyUp={handleInputKeyUp}>
                  {
                    Object.keys(EclipseTitle).map((title) => {
                      return (<MenuItem key={title}
                        value={title}>{title}</MenuItem>)
                    })
                  }
                </ValidationTextField>
                {errors.title && <Danger><small>{errors.title}</small></Danger>}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <ValidationTextField
                  fullWidth
                  label={isAssistedSigUp ? "Full name(s) as on their ID" : "Your first name(s) as on your ID"}
                  variant="filled"
                  id="firstName"
                  type="text"
                  error={!!(errors.firstName)}
                  name="firstName"
                  value={inputs.firstName}
                  onChange={handleInputChange}
                  onKeyUp={handleInputKeyUp} />
                {errors.firstName && <Danger><small>{errors.firstName}</small></Danger>}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <ValidationTextField
                  fullWidth
                  label={isAssistedSigUp ? "Surname as on their ID" : "Your surname as on your ID"}
                  variant="filled"
                  id="surname"
                  type="text"
                  error={!!(errors.surname)}
                  name="surname"
                  value={inputs.surname}
                  onChange={handleInputChange}
                  onKeyUp={handleInputKeyUp} />
                {errors.surname && <Danger><small>{errors.surname}</small></Danger>}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <ValidationTextField
                  fullWidth
                  label={isAssistedSigUp ?
                    (document?.type === "PASSPORT" ? "Passport number" : "Identity number")
                    : (document?.type === "PASSPORT" ? "Your passport number" : "Your identity number")}
                  variant="filled"
                  id="identityNumber"
                  type="text"
                  error={!!(errors.identityNumber)}
                  name="identityNumber"
                  value={inputs.identityNumber}
                  onChange={handleInputChange}
                  onKeyUp={handleInputKeyUp} />
                {errors.identityNumber && <Danger><small>{errors.identityNumber}</small></Danger>}
              </GridItem>
              {isExpiryDateEnable ?
                <GridItem xs={12} sm={12} md={12}>
                  <ValidationTextField
                    inputProps={{ min: currentDate }}
                    fullWidth
                    label="The expiry date of the document"
                    variant="filled"
                    id="expiryDate"
                    type="date"
                    error={!!(errors.expiryDate)}
                    name="expiryDate"
                    value={inputs.expiryDate}
                    onChange={handleInputChange}
                    onKeyUp={handleInputKeyUp} />
                  {errors.expiryDate && <Danger><small>{errors.expiryDate}</small></Danger>}
                </GridItem>
                : null}
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <Button className={classes.buttonRadius} size="lg" block color="primary" type="submit"
                  disabled={Object.keys(errors).length > 0}>{isAssistedSigUp ? 'Next' : 'Done'}</Button>
              </GridItem>
            </GridContainer>
          </form>
        </GridItem>
      </GridContainer>
      {alertData?.isAlertDisplay ? <AlertNotification alertData={alertData} /> : null}
    </div>
  );
}

const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

const mapDispatchToProps = dispatch => ({
  logoutFromAppHandler: data => dispatch(logoutFromApp(data)),
  personalInformationHandler: data => dispatch(loginToApp(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInformation)
